import React from "react";
import injectSheet from "react-jss";
import NumberFormat from "react-number-format";

import { roundToNearest } from "../../budget/selectors";

const OfferConfiguration = (props) => {
	const { budgetSelection, classes, configurationSelection } = props;

	return (
		<div className={`${classes.container}`}>
			{configurationSelection.selection.map((selection) => (
				<div
					className={`${classes.optionContainer}`}
					key={`confOption-${selection.title}`}
				>
					<h4>{selection.title}</h4>
					<p>{selection.option.title}</p>
					{selection.option.price > 0 ? (
						<p>
							<NumberFormat
								displayType="text"
								prefix="("
								suffix={` ${budgetSelection.currency})`}
								thousandSeparator="'"
								value={roundToNearest(selection.option.price)}
							/>
						</p>
					) : (
						<p />
					)}
				</div>
			))}
		</div>
	);
};

const styles = (theme) => ({
	container: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
		borderBottom: `2px solid ${theme.colors.secondary_3a}`,
	},
	optionContainer: {
		width: `${100 / 3}%`,
		padding: `${theme.sizes.gutter / 2}px`,
		"& h4": {
			marginTop: 0,
		},
		"& p": {
			margin: `${theme.sizes.gutter / 4}px 0`,
			"&:last-of-type": {
				marginBottom: 0,
			},
		},
	},
});

export default injectSheet(styles)(OfferConfiguration);



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerConfiguration.jsx